import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getApiUrl } from '../../config/demoMode';

const API_URL = getApiUrl();

export default function DemoSuresiDoldu() {
  const { logoutUser } = useAuth();
  const navigate = useNavigate();

  const handleCikis = async () => {
    try {
      if (API_URL) await fetch(`${API_URL}/Auth/logout`, { method: 'POST', credentials: 'include' });
    } catch {}
    logoutUser();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h1 className="text-white text-2xl font-bold mb-2">Demo Süresi Doldu</h1>
        <p className="text-gray-400 text-sm mb-6">
          Deneme süreniz sona erdi. HotelFlow'u kullanmaya devam etmek için
          lütfen bizimle iletişime geçin.
        </p>
        <div className="bg-gray-800 rounded-xl p-4 mb-6 text-left space-y-2">
          <div className="text-xs text-gray-500 font-semibold uppercase tracking-wider mb-2">İletişim</div>
          <div className="flex items-center gap-2 text-sm text-gray-300">
            <svg className="w-4 h-4 text-gray-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <span>info@hotelflow.com.tr</span>
          </div>
        </div>
        <button
          onClick={handleCikis}
          className="w-full bg-gray-700 hover:bg-gray-600 text-white font-semibold py-3 rounded-lg transition-colors"
        >
          Giriş Sayfasına Dön
        </button>
      </div>
    </div>
  );
}
